(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    /**
   * Avalon PDP: marks the thumbnail row or column with data-more while there are thumbnails beyond the
   * visible ones, so the CSS can fade the bottom edge.
   */
  (() => {
    const SELECTOR = '.slideshow-controls__thumbnails-container';

    const update = (container) => {
      const moreBelow = container.scrollHeight - container.scrollTop - container.clientHeight > 2;
      const moreRight = container.scrollWidth - container.scrollLeft - container.clientWidth > 2;
      const hasMore = moreBelow || moreRight;
      container.toggleAttribute('data-more', hasMore);
    };

    const updateAll = () => document.querySelectorAll(SELECTOR).forEach(update);

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.matches(SELECTOR)) update(event.target);
      },
      true
    );
    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('load', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    document.addEventListener('DOMContentLoaded', updateAll);
    updateAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
